import { render, staticRenderFns } from "./MessageViewer.htm?vue&type=template&id=fa7cc252&scoped=true&"
import script from "./MessageViewer.ts?vue&type=script&lang=js&"
export * from "./MessageViewer.ts?vue&type=script&lang=js&"
import style0 from "./MessageViewer.scss?vue&type=style&index=0&id=fa7cc252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7cc252",
  null
  
)

export default component.exports